import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { CollapsableIconCard } from 'modules/processes/components/CollpsableIconCard'
import { usePreviewProvider } from 'modules/processes/components/ItemWizard/Providers/preview'

export const IDUploadPreview = () => {
  const { previewValues } = usePreviewProvider()

  const uploadIdCertificate = previewValues.requestId?.uploadIdCertificate

  if (!uploadIdCertificate) return null

  return (
    <Box paddingTop="s24" gap="s4" paddingBottom="s12">
      <Text.Normal weight="semibold" color="grey1000">
        {i18n.t('processes.process_settings.wizard.tasks.types.request_id.preview.upload_id')}
      </Text.Normal>
      <Box padding="s0" flexDirection="row">
        <Text.Normal>
          {i18n.t('processes.process_settings.wizard.tasks.types.request_id.preview.id_copy.first')}
        </Text.Normal>

        <Box paddingLeft="s4">
          <Text.Normal weight="semibold">
            {i18n.t(
              'processes.process_settings.wizard.tasks.types.request_id.preview.id_copy.second'
            )}
          </Text.Normal>
        </Box>
      </Box>
      <Box padding="s0" flexDirection="row">
        <Text.Normal>
          {i18n.t(
            'processes.process_settings.wizard.tasks.types.request_id.preview.store_copy.first'
          )}
        </Text.Normal>

        <Box paddingLeft="s4">
          <Text.Normal weight="semibold">
            {i18n.t(
              'processes.process_settings.wizard.tasks.types.request_id.preview.store_copy.second'
            )}
          </Text.Normal>
        </Box>
      </Box>
      <Box gap="s12" paddingTop="s8">
        <CollapsableIconCard
          title={i18n.t(
            'processes.process_settings.tasks.form.super_tasks_module.data_collection.id_certificate.front'
          )}
          cta={i18n.t(
            'processes.process_settings.tasks.form.super_tasks_module.data_collection.id_certificate.cta'
          )}
          disabled
          leftIcon={{
            icon: 'id',
            color: 'viridian1000',
            background: 'viridian100',
          }}
        />
        <CollapsableIconCard
          title={i18n.t(
            'processes.process_settings.tasks.form.super_tasks_module.data_collection.id_certificate.back'
          )}
          cta={i18n.t(
            'processes.process_settings.tasks.form.super_tasks_module.data_collection.id_certificate.cta'
          )}
          disabled
          leftIcon={{
            icon: 'id-back',
            color: 'viridian1000',
            background: 'viridian100',
          }}
        />
      </Box>
    </Box>
  )
}
